// ** React Imports
import { useCallback, useMemo } from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Hooks
import useOpenGraphMetaTags from "hooks/useOpenGraphMetaTags";

// ** Config
import configGlobal from "configuration";

// #####################################################

const useGalleryMetaTags = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors", "pages"]);

	// ** Tytuł Strony - Atrybut 'title'
	const title = t("pages:galleries");

	// ** Meta Description
	const metaDescription = useMemo(() => {
		return `Umawiaj się na sex spotkania albo znajdź partnera na dłużej! Zobacz najnowsze galerie. Płeć:  Kobieta, Mężczyzna, Para, Trans.`;
	}, []);

	// ** Open Graph Meta Tags
	const ogMetaTags = useOpenGraphMetaTags({
		customTitle: `${title} - ${t("common:titleTemplate")}`,
		customDescription: metaDescription,
	});

	const canonicalLink = useCallback(() => {
		return (
			<link
				rel="canonical"
				href={`https://${configGlobal.host}/galleries`}
			/>
		);
	}, []);

	// #####################################################

	return { title, metaDescription, ogMetaTags, canonicalLink };
};

// #####################################################

export default useGalleryMetaTags;

// #####################################################
